import { Injectable } from '@angular/core';
import { BaseProvider } from '../../../../../shared/providers/base-provider';
import { TocNotifier } from './toc-notifier';
import { TocState } from './toc-state';

@Injectable()
export class TocProvider extends BaseProvider<TocNotifier, TocState> {
  constructor() {
    super(TocNotifier);
  }
}


